import type { Structure } from "model/OrganizationalStructure";

interface OrganizationalStructureError {
  readonly err: Error;
  readonly message: string;
}

export type OrganizationalStructureActions =
  | { readonly type: "GET_COMPANY_STRUCTURE"; readonly payload: Structure }
  | {
      readonly type: "SET_REQUEST_ERROR";
      readonly payload: OrganizationalStructureError;
    };

export interface OrganizationalStructureState {
  readonly error: OrganizationalStructureError | null;
  readonly structure: Structure;
}

export const organizationalStructureInitState: OrganizationalStructureState = {
  error: null,
  structure: { entities: [] },
};

export const organizationalStructureStateReducer = (
  state: OrganizationalStructureState,
  action: OrganizationalStructureActions,
): OrganizationalStructureState => {
  switch (action.type) {
    case "GET_COMPANY_STRUCTURE":
      return { ...state, error: null, structure: action.payload };
    case "SET_REQUEST_ERROR":
      return { ...state, error: action.payload };
  }
};
